// extracted by mini-css-extract-plugin
export default {"root":"ellipse_root__TUdk6","small":"ellipse_small__cHKDY","medium":"ellipse_medium__+mhnf"};